<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="ico-cara" viewBox="0 0 512 512">
        <path d="m254 56c-1 0-12 4-26 9-22 7-52 17-187 63-20 7-38 13-39 13l-2 1 0 252 28 0c24 0 28 1 28 1 0 1 0 2-1 4-8 18-2 39 15 51 15 10 36 8 50-5 12-12 16-27 10-44-1-4-1-5-1-6 1 0 30-1 46-1l9 0 0 63 144 0 0-63 15 1c22 0 50 0 51 1 0 0 0 1-1 3-4 8-5 19-3 26 4 14 14 25 27 29 6 2 15 3 21 1 13-3 23-10 29-23 3-6 3-7 3-18 0-9 0-9-2-14l-2-5 16 0c9 0 19-1 23-1l7 0 0-252-9-3c-12-4-65-22-114-39-116-39-130-44-132-44-1 0-2 0-3 0z m31 31c71 23 205 69 206 70 0 0 0 32 1 109l0 108-27 0c-15 0-52 1-82 1l-55 0 0-205-144 0 0 205-55 0c-30 0-67-1-82-1l-27 0 0-109 1-108 22-8c21-7 55-19 132-45 48-16 80-27 80-27 1 0 14 4 30 10z m22 196l0 92-102 0 0-184 102 0z m0 117l0 6-102 0 0-5c0-3 0-5 0-6 0 0 9-1 51 0l51 0z m-211-4c4 1 7 2 10 5 6 6 8 15 4 23-5 12-21 15-31 6-9-7-9-21-1-29 3-3 5-4 9-5 3-1 4-1 9 0z m343 1c4 2 8 7 9 10 2 4 2 14 1 17-1 2-6 7-9 9-10 6-23 2-28-9-1-3-2-4-2-9 0-5 1-6 2-8 1-3 6-8 9-9 5-3 13-3 18-1z m-132 34l0 5-102 0 0-10 102 0z m-256-200l0 62 103 0 0-123-103 0z m82 0l0 41-61 0 0-81 61 0z m225 0l0 62 103 0 0-123-103 0z m82 0l0 41-61 0 0-81 61 0z"/>
      </symbol>
    </svg>
    <div class="filters" :class="{'show': $props.showFilters}">
      <div class="section features">
        <h3>Features</h3>
        <Checkbox
                :data.sync="$props.filter.wifi"
                :item="'Wifi'"
                :icon="'#ico-wifi'"
                @track="$props.track"
        />
        <Checkbox
                :data.sync="$props.filter.hot_tub"
                :item="'Hot Tub'"
                :icon="'#ico-tub'"
                @track="$props.track"
        />
      </div>
      <Checkbox
              :data.sync="$props.filter.pets"
              :item="'Pets'"
              :icon="'#ico-pet'"
              @track="$props.track"
      />
      <div class="section beds">
        <h3>Bedrooms</h3>
          <Select
            :data.sync="$props.filter.beds"
            :options="options.bedroom"
            :name="'Bedrooms'"
            :placeholder="'Bedrooms'"
            :required="false"
            :classN="'light'"
            :icon="'#ico-bed'"
            @track="$props.track"
          />
      </div>
      <div class="section sleeps">
        <h3>Sleeps</h3>
          <Select
            :data.sync="$props.filter.sleeps"
            :options="options.guest"
            :name="'Guests'"
            :placeholder="'Guests'"
            :classN="'light'"
            :required="true"
            :icon="'#ico-group'"
            @track="$props.track"
          />
      </div>
      <div class="section accomm">
        <h3>Accommodation</h3>
        <Checkbox
            :data.sync="$props.filter.lodge"
            :item="'Lodge'"
            :icon="'#ico-cottage'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.caravan"
            :item="'Caravan'"
            :icon="'#ico-cara'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.cottage"
            :item="'Cottage'"
            :icon="'#ico-cottage'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.apartment"
            :item="'Apartment'"
            :icon="'#ico-big'"
            @track="$props.track"
        />
      </div>

      <div class="right">
        <button class="btn" @click="$emit('closeAndCancel', false)">Close</button>
        <button class="btn orange" @click="$emit('getData', false)">Apply</button>
      </div>
    </div>

    <div class="mobile-filters" v-if="$props.isMobile" :class="{'show': $props.showFilters && $props.isMobile}">
        <div class="head">
          <div class="close" @click="$emit('closeAndCancel', false)">✕</div>
        </div>
    <div class="padding">
      <div class="section features">
        <h3>Features</h3>
        <Checkbox
                :data.sync="$props.filter.wifi"
                :item="'Wifi'"
                :icon="'#ico-wifi'"
                @track="$props.track"
        />
        <Checkbox
                :data.sync="$props.filter.hot_tub"
                :item="'Hot Tub'"
                :icon="'#ico-tub'"
                @track="$props.track"
        />
      </div>
      <div class="section beds">
        <h3>Bedrooms</h3>
          <Select
            :data.sync="$props.filter.beds"
            :options="options.bedroom"
            :name="'Bedrooms'"
            :placeholder="'Bedrooms'"
            :required="false"
            :classN="'light'"
            :icon="'#ico-bed'"
            @track="$props.track"
          />
      </div>
      <div class="section sleeps">
        <h3>Sleeps</h3>
          <Select
            :data.sync="$props.filter.sleeps"
            :options="options.guest"
            :name="'Guests'"
            :placeholder="'Guests'"
            :classN="'light'"
            :required="true"
            :icon="'#ico-group'"
            @track="$props.track"
          />
      </div>
      <div class="section accomm">
        <h3>Accommodation</h3>
        <Checkbox
            :data.sync="$props.filter.lodge"
            :item="'Lodge'"
            :icon="'#ico-cottage'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.caravan"
            :item="'Caravan'"
            :icon="'#ico-cara'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.cottage"
            :item="'Cottage'"
            :icon="'#ico-cottage'"
            @track="$props.track"
        />
        <Checkbox
            :data.sync="$props.filter.apartment"
            :item="'Apartment'"
            :icon="'#ico-big'"
            @track="$props.track"
        />
      </div>
    <div class="right">
      <button class="btn" @click="$emit('closeAndCancel', false)">Close</button>
      <button class="btn orange" @click="$emit('getData', false)">Apply</button>
    </div>
      </div>
    </div>

  </div>
</template>

<script>
import Checkbox from 'shared/checkbox.vue';
import Select from 'shared/select.vue';

export default {
   data: function () {
      return {
      }
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    showFilters: Boolean,
    isMobile: Boolean,
    options: Object,
    track: Function,
    formatActiveFilters: Function
  },
  components: {
      Checkbox, Select
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.filters {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  position: absolute;
  background: $col_white;
  width: 100%;
  left: 0;
  padding: 0 1rem;
  box-sizing: border-box;
  box-shadow: 0 0.125rem 0.25rem #ccc;
  z-index: 5;
  top: 10rem;

  &.show {
    max-height: 70rem;
    padding: 0 1rem 1rem;
  }
}

.section {
  padding: 1rem 0 0 0;
  clear: both;
}

h3 {
  margin: 0 0 1rem;
}

.right {
  padding: 1.25rem 0 2rem;
  clear: both;
}

.btn {
  width: 8rem;
  background: $col_grey;
  font-weight: 700;
  height: 2.5rem;
  font-size: .875rem;
  border-radius: .3rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.15);
  cursor: pointer;
  outline: none;

  &.orange {
    color: $col_white;
    background: $col_orange;
    margin: 0 0 0 .5rem;
  }

  &:focus {
    box-shadow: 0 0.125rem 1.25rem 0 $col_aqua;
  }
}

.padding {
  padding: 1.25rem 1.25rem 0 1.25rem;
}

 .close {
    top: 0.625rem;
    left: 1.25rem;
    position: absolute;
    font-size: 1.4rem;
    z-index: 10;
    cursor: pointer;
  }

  .head {
    height: 3.125rem;
    position: relative;

    &:after{
      content: "";
      background: #919195;
      height: 0.063rem;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }

.mobile-filters {
  position: fixed;
  z-index: 10;
  height: 100%;
  background: $col_white;
  top: 0;
  left: 0;
  width: 100%;
  display: none;
  box-sizing: border-box;

  &.show {
    display: block;
  }

  .right {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 1.25rem;
    box-sizing: border-box;

    .btn {
      width: calc(30% - 0.625rem);
      float: left;
      margin: 0 0.625rem 0 0;

      &.orange {
        width: 70%;
        margin: 0;
      }
    }
  }
}

@media #{$desktop} {
  .btn {
    width: 12rem;
  }

  .filters {
    padding: 0 1.25rem;
    top: 5.313rem;

    &.show {
      padding: 0 1.25rem 0;
    }
  }
}

</style>